import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import {
  ANY_SPORT_PLAY_EVENTTYPE_FIXTURE,
  ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_REWARDS,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { glossary } from '@sorare/core/src/lib/glossary';

type Props = {
  baseRoute:
    | typeof ANY_SPORT_PLAY_EVENTTYPE_FIXTURE
    | typeof ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_REWARDS;
  currentEventType: So5FixtureEvent;
};

export const EventTypeSwitcher = ({ currentEventType, baseRoute }: Props) => {
  const navigate = useNavigate();
  const { generateSportContextPath } = useSportContext();
  const [selectedEventType, setSelectedEventType] = useState(currentEventType);

  return (
    <Vertical gap={0.5}>
      <TabBar
        variant="primary"
        value={selectedEventType}
        onValueChange={value => {
          setSelectedEventType(value as So5FixtureEvent);
          navigate(
            generateSportContextPath(baseRoute, {
              params: {
                eventType: value.toLowerCase(),
                fixture: 'ongoing',
              },
            })
          );
        }}
      >
        <Tab value={So5FixtureEvent.DAILY}>
          <FormattedMessage {...glossary.daily} />
        </Tab>
        <Tab value={So5FixtureEvent.CLASSIC}>
          <FormattedMessage {...glossary.biweekly} />
        </Tab>
      </TabBar>
    </Vertical>
  );
};
